import React from 'react';
import styled from 'styled-components';

import { Grid, Cell } from '../grid';

const Container = styled.div`
  background: #08111e;
  padding: 0 25px;
  padding-top: 44px;
`;

const ImageGridInner = styled.div`
  max-width: 1290px;
  margin: 0 auto;
  text-align: center;
`;

const ImgContainer = styled.div`
  padding: 10px;
  img {
    width: 180px;

    @media (max-width: 520px) {
      width: 180px;
    }

    @media (max-width: 450px) {
      width: 160px;
    }
  }
`;

const ImageFlexGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

function CurrencyImageGrid({ input }) {
  return (
    <Container>
      <ImageGridInner>
        <ImageFlexGrid>
          {input.items.map((item, i) => {
            return (
              <div key={i} xs={2} sm={1}>
                <ImgContainer><a href={item.link.url}><img src={item.image.url} /></a></ImgContainer>
              </div>
            );
          })}
        </ImageFlexGrid>
      </ImageGridInner>
    </Container>
  );
}

export { CurrencyImageGrid };
